const operationArchivesEn = {
  equipmentAdditionalCount: '{{count}} more',
  filters: {
    allPackages: 'All Packages',
    allTargets: 'All Targets',
    anchorDatePlaceholder: 'Anchor Date',
    clearFilters: 'Clear Filters',
    operationPackagePlaceholder: 'Operation Package',
    targetPlaceholder: 'Target',
    textSearchPlaceholder: 'Search operator, pattern...'
  },
  status: {
    archived: 'Archived',
    completed: 'Completed',
    inProgress: 'In Progress'
  }
};
export default operationArchivesEn;